import React from 'react'
import { Route, Link, BrowserRouter as Router, Switch } from 'react-router-dom'
import axios from 'axios';
import { BaseUrl } from '../../settings'
import Modal from 'react-bootstrap/Modal'
import 'style/Message.css'
import Utils from 'Utils'
import AudioPlayer from 'react-modular-audio-player';
import sanitizeHtml from 'sanitize-html';
import { PlyrComponent } from 'plyr-react';
import InsertDriveFileRoundedIcon from '@material-ui/icons/InsertDriveFileRounded';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import DoneIcon from '@material-ui/icons/Done';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import Loading from 'components/Loading'
import InsertPhotoOutlinedIcon from '@material-ui/icons/InsertPhotoOutlined';




const MyMessageStyle = {
  backgroundColor: '#26a69a',
  borderRadius: '5px',
  color: '#fff',
  padding: '5px 9px',
  border: '1px solid #1f897f'
}



const matrixBaseUrl = 'https://msg.tebinja.com';

export class TextMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isRead: props.isRead || false
    }
  }
  render() {

    return (
      <div className={`ChatMessage ${this.props.me ? 'Mine' : ''} ${this.props.me === null ? 'MessageCenter' : ''}`} >
        <span className="text" dangerouslySetInnerHTML={{ __html: this.props.text ? Utils.createTextLink(sanitizeHtml(this.props.text)) : ' ' }}>
          {/* {this.props.text ? Utils.createTextLink(this.props.text) : ' '} */}
        </span>
        <div className='MoreInfo'>
          {this.props.time ? <div className="chatTime">{Utils.timeStampToHHMM(this.props.time)}</div> : ''}
          {this.props.me ? this.props.isRead?<DoneAllIcon className='ReadSize'/>:<DoneIcon className='ReadSize'/> : null}
        </div>
      </div>
    )

  }
}


export class VideoMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isRead: props.isRead || false
    }
    this.source = {
      type: 'video', sources: [{ src: props.src }]
    }
    this.options = { controls: ['play-large', 'play', 'progress', 'current-time', 'airplay', 'fullscreen'] }
    this.state = {
      isRead: props.isRead || false
    }

  }
  render() {

    return (
      <div className={`ChatMessage ${this.props.me ? 'Mine' : ''} image`} >
        {/* <video src={this.props.src} controls autoplay  ></video > */}
        <PlyrComponent sources={this.source} options={this.options} />
        <div className='MoreInfo'>
          {this.props.time ? <div className="chatTime">{Utils.timeStampToHHMM(this.props.time)}</div> : ''}
          {this.props.me ? this.props.isRead?<DoneAllIcon className='ReadSize'/>:<DoneIcon className='ReadSize'/> : null}
        </div>
      </div>
    )

  }
}

export class ApplicationMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isRead: props.isRead || false
    }
    this.tokens = this.props.title && this.props.title.split('.')
    this.type = this.tokens.length > 0 ? this.tokens[this.tokens.length - 1].toUpperCase() : ''
  }
  render() {

    return (
      <div className={`ChatMessage ${this.props.me ? 'Mine' : ''} image application`} >
        <a className='application-wrapper' target="_blank" href={this.props.src} download>
          <InsertDriveFileRoundedIcon style={{}} />
          <span className='title'>{this.props.title}</span>
          <GetAppRoundedIcon style={{ fontSize: 31 }} />
        </a>
        <div className='MoreInfo'>
          {this.props.time ? <div className="chatTime">{Utils.timeStampToHHMM(this.props.time)}</div> : ''}
          {this.props.me ? this.props.isRead?<DoneAllIcon className='ReadSize'/>:<DoneIcon className='ReadSize'/> : null}
        </div>
        <div className="descLine"><span>{this.type}</span></div>
      </div>
    )

  }
}


export class AudioMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isRead: props.isRead || false,
      sources: {
        type: 'audio',
        sources: [
          {
            src: this.props.audioUrl,
          },
        ],
      }
    }
  }
  render() {

    return (
      <div className={`ChatMessage ${this.props.me ? 'Mine' : ''}`} >
        <AudioPlayer
          hideForward={true}
          hideLoop={true}
          hideRewind={true}
          hideName={true}
          iconSize="30px"
          fontFamily="YekanBakh"
          sliderClass="my-slider"
          playIcon="/images/play.svg"
          playHoverIcon="/images/play.svg"
          pauseIcon="/images/pause.svg"
          pauseHoverIcon="/images/pause.svg"
          audioFiles={[{ src: this.props.audioUrl }]}
        />
        {/* <PlyrComponent sources={this.state.sources} options={{
          controls: [
            'play',
            'progress',
            'current-time',
            'duration',
          ]
        }} /> */}
      <div className='MoreInfo'>
        <div class="chatTime">{Utils.timeStampToHHMM(this.props.time)}</div>
        {this.props.me ? this.props.isRead ?<DoneAllIcon className='ReadSize'/>:<DoneIcon className='ReadSize'/> : null}
      </div>
      </div>
    )

  }
}
export class ImageMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openModal: false,
      isRead: props.isRead || false,
    }
  }

  toggleModa() {
    // console.log('asd>>>>')
    this.setState(prevState => ({
      openModal: !prevState.openModal
    }));
  };
  render() {
    return (


      <div className={`ChatMessage image ${this.props.me ? 'Mine' : ''}`} onClick={() => this.props.showImageModal(this.props.src)}>
        {this.props.loadingMessage ?
          <>
            <span className="text">
              <div className="image-loading">
                <Loading />
              </div>
              <div className="image-preview">
                <InsertPhotoOutlinedIcon style={{ color: '#ccc', fontSize: 100 }} />
              </div>
            </span>
          </> :
          <>
            <img src={this.props.src} style={{ width: '100%' }} />
            <div className='MoreInfo'>
              <div className="chatTime">{Utils.timeStampToHHMM(this.props.time)}</div>
              {this.props.me ? this.props.isRead?<DoneAllIcon className='ReadSize'/>:<DoneIcon className='ReadSize'/> : null}
            </div>

            <div id="modal01" className="w3-modal" >
              <span className="w3-button w3-hover-red w3-xlarge w3-display-topright">&times;</span>
              <div className="w3-modal-content w3-animate-zoom">
                <img src={this.props.src} style={{ width: '100%' }} />
              </div>
            </div>
          </>
        }
      </div>
      // <Row style={RowStyle}>
      //   <Col xs={this.props.me ? { span: 11, offset: 1 } : 11} className={this.props.me ? 'rtl' : null}>
      //     <div style={{ backgroundImage: `url(${this.props.src}`, backgroundPosition: 'center', backgroundSize: 'cover', height: 275, width: 200 }}>
      //       <Button variant="primary" onClick={() => this.setState({ openModal: true })} style={{ height: '100%', opacity: 0 }}>
      //         Launch vertically centered modal
      // 		      </Button>
      //     </div>



      //     {/* <Modal
      //       onHide={() => this.setState({ openModal: false })}
      //       show={this.state.openModal}
      //       size="lg"
      //       aria-labelledby="contained-modal-title-vcenter"
      //       centered
      //     >
      //       <img src={this.props.src} style={{ width: '100%', height: 'auto' }}></img>
      //     </Modal> */}
      //   </Col>
      // </Row>
    )

  }
}
